












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DialogBox extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;

}
